// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.
import './LoadingIcon.scss';

import icon from '../../assets/icons/white/loading.png';

export default function LoadingIcon() {
  return (
    <div className='loading-icon'>
      <img src={icon} />
    </div>
  );
}
